<template>
    <ul>
        <li v-for="item in salesItems">
            <router-link :to="`/store/${store.id}/sales_item/${item.id}`">{{ item.name }}</router-link>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'SalesItemList',
    props: ['store', 'salesItems']
}
</script>
